import { Link } from "react-router-dom";
import { NAV_ITEMS } from "@/components/feature/SiteHeader";
import { categoryMeta } from "@/mocks/articles";

const categories = [
  categoryMeta.news,
  categoryMeta.recommendations,
  categoryMeta.stars,
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2" aria-label="蜜桃33 首页">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-bold tracking-tight">
                蜜桃<span className="text-primary-300">33</span>
              </span>
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200/80">
              综合娱乐资讯平台，聚合最新娱乐新闻、影视推荐与明星动态，帮你用更少的时间读懂娱乐热点。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {[
                { icon: "ri-weibo-fill", label: "微博" },
                { icon: "ri-wechat-fill", label: "微信" },
                { icon: "ri-youtube-fill", label: "视频号" },
                { icon: "ri-mail-line", label: "邮箱" },
              ].map((item) => (
                <span
                  key={item.label}
                  title={item.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${item.icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              内容分类
            </h3>
            <ul className="mt-4 space-y-3 text-sm">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-background-200/80 transition-colors hover:text-primary-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              快速导航
            </h3>
            <ul className="mt-4 space-y-3 text-sm">
              {NAV_ITEMS.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-background-200/80 transition-colors hover:text-primary-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/search"
                  className="text-background-200/80 transition-colors hover:text-primary-300"
                >
                  站内搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              联系我们
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-background-200/80">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-300" />
                <span>contact@mitao33.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-contacts-book-2-line mt-0.5 text-primary-300" />
                <span>商务合作：biz@mitao33.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-primary-300" />
                <span>北京市朝阳区创意园 3 号楼 8 层</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/10 pt-6 text-xs text-background-200/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 蜜桃33 版权所有 · 本站内容为演示示例</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>隐私政策</span>
            <span>用户协议</span>
            <span>内容合作</span>
          </p>
        </div>
      </div>
    </footer>
  );
}